const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.48,395.13s-13-4.79-15.54,4.79c0,0,2.32,10.55.93,16.32s-8.39,16.79-8.82,18.88c-.85,4.1-.21,4.38-.21,4.38s5.09,2.94,11.93-.21,18.68-16.71,20.53-19.5S359.5,406,359.5,406Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.88,224.6h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H235a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "matrix(1, 0.09, -0.09, 1, 20.91, -20.38)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.74,227.86h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H272.86a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "translate(21.32 -23.61) rotate(4.91)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.19,246.39,333,318.32l-115.89-10,6.19-71.92a4.54,4.54,0,0,1,4.92-4.14l106.82,9.18A4.54,4.54,0,0,1,339.19,246.39Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.8,408.81s-5.54-3.95-17-3.16c0,0-.84,13.75-2.4,17.75s-9.78,10.93-11.31,12.12-1.53,5.34-1.53,5.34h34.82a110.91,110.91,0,0,0-2.77-17.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.68,268.23s-22.21,4.35-44-2.71A63,63,0,0,1,341.55,259s.06-1.4.1-3.69c.18-8.94.13-31.43-4.58-37-3-3.51-5.35-25.21.44-36.18l17.71-14.24c24.52,4.79,29.7,11.28,33.75,25.28.75,2.56,1.45,5.37,2.23,8.47.85,3.38,1.65,7.51,2.41,12C397.29,236,399.68,268.23,399.68,268.23Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.11,247.91l4,8.48s16.54,34.18,26.67,73.32c.24.93,5.48,19.47,1.28,65.64l2.4,8.1-2.62,13.38s3.94,5.69,3.8,7.55c0,0-9.72,1.81-13,3.55-2.52,1.36-10.09,8.83-10.09,8.83-2.15-.44-2.34-9.12-2.34-9.12s-4.49-77.07-5.78-80.39-9.17-17.64-21.47-50.41c0,0-.28,45.77-3.56,57.35-2.93,10.3.54,39.13.54,39.13l-2,32.09s6.92,7.19,1.31,9.12c0,0-3.75-7.21-14.43-8.85-5.43-.84-12.19,8.8-12.19,8.8-2.38-.76,1-12.87,1-12.87-7.57-57.12-2-46.78-3.5-74.7-1-17.92-6.05-94.58-.09-100.81Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196,104h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H194.16a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,196,104Z",
    transform: "translate(-9.49 19.5) rotate(-5.27)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.88,100.49h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H232a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,233.88,100.49Z",
    transform: "translate(-9.01 22.96) rotate(-5.27)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.21,109.42l6.64,71.88L190,192,183.4,120.1a4.55,4.55,0,0,1,4.11-4.95l106.76-9.85A4.54,4.54,0,0,1,299.21,109.42Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H214.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,216.33,357.31Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H252.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,254.33,357.31Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.42,371.23v72.19H203.11V371.23a4.55,4.55,0,0,1,4.55-4.55H314.87A4.55,4.55,0,0,1,319.42,371.23Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,112.47C123.46,96.39,141.65,84,163.33,84.21c37,.46,57,33.21,78.22,58.47,11,13.1,23.49,25.74,39.83,31.9,24.51,9.23,51.81,3.84,75.69-4.73,10.7-3.84,23.37-9.24,35.42-6.48,36.63,8.38,32.82,53.08,26.77,81.39C411.09,283,397.81,323.66,370.9,353c-64.43,70.29-180.38,27.2-238.5-28.89-4.27-4.13-8.36-8.43-12.21-13A179.75,179.75,0,0,1,95,272.74C76.28,233.79,73.7,186.45,90,146.2A128,128,0,0,1,110,112.47Z",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,112.47C123.46,96.39,141.65,84,163.33,84.21c37,.46,57,33.21,78.22,58.47,11,13.1,23.49,25.74,39.83,31.9,24.51,9.23,51.81,3.84,75.69-4.73,10.7-3.84,23.37-9.24,35.42-6.48,36.63,8.38,32.82,53.08,26.77,81.39C411.09,283,397.81,323.66,370.9,353c-64.43,70.29-180.38,27.2-238.5-28.89-4.27-4.13-8.36-8.43-12.21-13A179.75,179.75,0,0,1,95,272.74C76.28,233.79,73.7,186.45,90,146.2A128,128,0,0,1,110,112.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 54.05,
    y1: 443.43,
    x2: 445.95,
    y2: 443.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-9"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "291.97 240.8 291.97 93.66 301.08 93.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.97,
    y1: 258.31,
    x2: 291.97,
    y2: 254.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "324.51 93.66 418.52 93.66 418.52 272.03 291.97 272.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.99,
    y1: 93.66,
    x2: 321.25,
    y2: 93.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.73,
    y: 98.41,
    width: 117.03,
    height: 168.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "408.32 107.45 408.32 177.58 302.17 177.58 302.17 173",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "302.17 162.28 302.17 103.39 408.32 103.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.17,
    y1: 169.49,
    x2: 302.17,
    y2: 165.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.39,
    y1: 182.84,
    x2: 413.76,
    y2: 182.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.08,
    y1: 182.84,
    x2: 385.39,
    y2: 182.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.73,
    y1: 182.84,
    x2: 378.14,
    y2: 182.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "349.36 177.58 349.36 175.16 359.15 175.16 359.15 176.53 355.25 176.53 355.25 177.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,246s1.63,1.23,2.77,8.67c0,0,2-11.88,4.34-12.06s1.9,7.72,1.9,7.72.4-3.89,2.26-3.71,0,8,0,8,2.24-6.14,4.36-6-1.4,11.12-1.4,11.12,5.44-3.94,7.64-2-1.22,6.78-1.22,6.78,7.8-1.69,9,2.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,263s3.4-2.23,6.08-1.19c0,0-1.7-2.59,0-4.17s3.88,4.17,3.88,4.17.25-9.65,3.65-9.16,0,9.16,0,9.16,6.07-5.38,7.53-3.51-1,4.7-1,4.7a6.58,6.58,0,0,1,6.32,1.55s4.07-4.15,8.59-4.75c0,0-3-8.73-1.55-10.49s4.11,7.62,4.11,7.62,1.16-6.1,5-6.58c0,0-3.17-1.72-2.23-4.33s5.31.62,5.31.62-1.8-4.59,1.05-5.85,4,3.84,4,3.84.8-5.34,4.14-5,2.26,6.44,2.26,6.44,3.15-4.88,4.84-4.39c3.37,1,2.35,8.72,2.35,8.72s4.7-3.27,5.92-1.76-4.9,5.81-4.9,5.81,4.67.51,7.58,3.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.76,247.8s-.54-4.9-5.44-5.16,1.35,10.75,1.35,10.75-4.05-3.35-5.5-2.32,4.15,6.71,4.15,6.71-2.69-2.49-5.52-1.72,1.61,8.66,1.61,8.66A20.18,20.18,0,0,0,392,266.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-9"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 246.69,
    y1: 399.65,
    x2: 246.69,
    y2: 443.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.69,
    y1: 385.41,
    x2: 246.69,
    y2: 394.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63.49 443.43 63.49 362.33 246.69 362.33 246.69 380.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.18 371.2 74.28 371.2 74.28 435.99",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "235.9 443.17 235.9 371.2 99.41 371.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.28,
    y1: 353.93,
    x2: 223.23,
    y2: 353.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.98 353.93 58.94 353.93 58.94 362.27 251.24 362.27 251.24 353.93 231.5 353.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,300.49s15,1.19,15.68,12.29C85.45,312.78,70.2,319.8,69.77,300.49Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,303.25s8.41-11.37,22-5.54C121.54,297.71,113.24,311.45,99.54,303.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39,267.35s2.42,21.87-17.49,15.85C102.9,283.2,109.22,267.12,120.39,267.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,255.17s15.75,8.5,4.17,21.38C100.11,276.55,89.07,267.35,95.94,255.17Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.57,274.72S93.69,273,93.69,288.84C93.69,288.84,76.57,289.52,76.57,274.72Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4,321.73c-.25-5.32-.25-12.16,3-19.39,7.49-16.68,10-30.73,6.11-40.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.19,279s10.26,4.08,13.75,14.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,276.1s-5.93,8.08-16,7.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,300s-16.43,4.73-23,3.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.67,305.49s7.35,8.06,14.73,7.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,321.73H73.24a.87.87,0,0,0-.87.87v2.71a.86.86,0,0,0,.87.86h1l3.18,27.76H104.7l3.18-27.76h1.05a.85.85,0,0,0,.86-.86V322.6A.86.86,0,0,0,108.93,321.73Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.57,
    y1: 326.17,
    x2: 97.33,
    y2: 326.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.24,
    y1: 326.17,
    x2: 104.36,
    y2: 326.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.71,211.09l-4,21.74-32.62,19.82,4.51,8.28s37.71-11.5,38.63-14.19,9.61-31.18,9.61-31.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,174.33l-2.18,26.36-1.15,13.83c-6.29,3.06-12.44-1.54-12.82-1.84h0C328.56,207.66,330.55,179.33,343,174.33Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.78,200.69l-1.15,13.83c-6.29,3.06-12.44-1.54-12.82-1.84.27.12,3.58,1.52,5.73,0a16.78,16.78,0,0,1-2-2.64c-.13-.52,2-.66,2-.66s-1.4-11.21,2.33-16C336.33,191.56,338.61,195.36,340.78,200.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.59,418.44l1,2.94a59.51,59.51,0,0,1-5.08,7.14s-1-.32-2.64,1.13a6.07,6.07,0,0,0-1.76,3.76s-7.64,9.16-17.33,9.29-6.77-4.75-6.77-4.75Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,395.13s-13-4.79-15.54,4.79c0,0,2.32,10.55.93,16.32s-8.39,16.79-8.82,18.88c-.85,4.1-.21,4.38-.21,4.38s5.09,2.94,11.93-.21,18.68-16.71,20.53-19.5S359.5,406,359.5,406Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.48,395.13s-13-4.79-15.54,4.79c0,0,2.32,10.55.93,16.32s-8.39,16.79-8.82,18.88c-.85,4.1-.21,4.38-.21,4.38s5.09,2.94,11.93-.21,18.68-16.71,20.53-19.5S359.5,406,359.5,406Z",
    style: {
      fill: "#556EE6",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,395.13s-13-4.79-15.54,4.79c0,0,2.32,10.55.93,16.32s-8.39,16.79-8.82,18.88c-.85,4.1-.21,4.38-.21,4.38s5.09,2.94,11.93-.21,18.68-16.71,20.53-19.5S359.5,406,359.5,406Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,408.68a28.23,28.23,0,0,1-3.25,18.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,430a8.77,8.77,0,0,1-5.56,5.14,15.47,15.47,0,0,1-8,0l3.12-6.32A19.94,19.94,0,0,0,346.58,430Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.42,426.17s-6.8.41-10.35-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.68,422.42s-6.36,1-9.91-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,418.25s-5.57.81-9.21-.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,413.53s-6.2,1.94-9.13,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.31,401.87l1.08,6.81s-8.2,5.4-13.62-1.35l0-7.11S341.81,405,352.31,401.87Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.19,249c-8.31,26.33-34.1,68.56-31.49,79.37,1.43,5.9,9.94,39.33,16.6,54,2.53,5.61,8,9.36,8,9.36l3.95,8.47c9.63,4.19,13.08-4.33,13.08-4.33l-1.94-9.6c5.16-9.38,3-9.38-3.71-58-.79-5.73,12.5-23.44,12.5-23.44L369,349.39l1.11,36.5,3.54,11.28s.88,10.59.8,11.23h15.83L392,396.76s7.35-6.93,7.35-14.93-1.58-48.75,0-60.62-3.7-67.21-3.7-67.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.88,224.6h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H235a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "matrix(1, 0.09, -0.09, 1, 20.91, -20.38)",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.88,224.6h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H235a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "matrix(1, 0.09, -0.09, 1, 20.91, -20.38)",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.04,
    y: 226.97,
    width: 6.33,
    height: 12.66,
    transform: "translate(20.93 -21.09) rotate(4.91)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.88,224.6h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H235a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "matrix(1, 0.09, -0.09, 1, 20.91, -20.38)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.74,227.86h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H272.86a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "translate(21.32 -23.61) rotate(4.91)",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.74,227.86h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H272.86a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "translate(21.32 -23.61) rotate(4.91)",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.98,
    y: 230.3,
    width: 3.82,
    height: 12.66,
    transform: "translate(21.35 -24.39) rotate(4.91)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.74,227.86h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H272.86a0,0,0,0,1,0,0v-15.7a1.88,1.88,0,0,1,1.88-1.88Z",
    transform: "translate(21.32 -23.61) rotate(4.91)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,227.17h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H264.89a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,266.77,227.17Z",
    transform: "translate(21.24 -22.93) rotate(4.91)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.63,230.43h22a1.88,1.88,0,0,1,1.88,1.88V248a0,0,0,0,1,0,0H302.75a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,304.63,230.43Z",
    transform: "translate(21.65 -26.16) rotate(4.91)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.93,
    y: 229.54,
    width: 6.33,
    height: 12.66,
    transform: "translate(21.26 -23.64) rotate(4.91)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.37,
    y: 232.76,
    width: 6.33,
    height: 12.66,
    transform: "translate(21.67 -26.84) rotate(4.91)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,246.39,333,318.32l-115.89-10,6.19-71.92a4.54,4.54,0,0,1,4.92-4.14l106.82,9.18A4.54,4.54,0,0,1,339.19,246.39Z",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.19,246.39,333,318.32l-115.89-10,6.19-71.92a4.54,4.54,0,0,1,4.92-4.14l106.82,9.18A4.54,4.54,0,0,1,339.19,246.39Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,246.39,333,318.32l-115.89-10,6.19-71.92a4.54,4.54,0,0,1,4.92-4.14l106.82,9.18A4.54,4.54,0,0,1,339.19,246.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,246.39,333,318.32l-86-7.4L253.2,239a4.54,4.54,0,0,1,4.92-4.14l76.93,6.61A4.54,4.54,0,0,1,339.19,246.39Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.15,248.45l-73.51-6.32a1.88,1.88,0,0,1-1.71-2h0a1.88,1.88,0,0,1,2-1.71l73.51,6.32a1.88,1.88,0,0,1,1.71,2h0A1.88,1.88,0,0,1,333.15,248.45Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,408.81s-5.54-3.95-17-3.16c0,0-.84,13.75-2.4,17.75s-9.78,10.93-11.31,12.12-1.53,5.34-1.53,5.34h34.82a110.91,110.91,0,0,0-2.77-17.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.8,408.81s-5.54-3.95-17-3.16c0,0-.84,13.75-2.4,17.75s-9.78,10.93-11.31,12.12-1.53,5.34-1.53,5.34h34.82a110.91,110.91,0,0,0-2.77-17.66Z",
    style: {
      fill: "#556EE6",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,408.81s-5.54-3.95-17-3.16c0,0-.84,13.75-2.4,17.75s-9.78,10.93-11.31,12.12-1.53,5.34-1.53,5.34h34.82a110.91,110.91,0,0,0-2.77-17.66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.61,410.59s-.82,12.66-2.79,16a23.13,23.13,0,0,1-3.86,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,433.34s-1.75,2.18-3.69,2.47-12.19-.29-12.19-.29l4.18-3.62S372.8,430.47,376,433.34Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.62,430.37s-7.42-4.26-12.71-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,427.48s-5.18-4.05-11.29-1.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.61,423.07s-5.58-4.34-11.46-1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.37,417.56s-6.77-3.64-11.69-.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.37,440.86v2.57h-4s-3.43-2-6.69,0H363.9a13.62,13.62,0,0,1-5.74-1.29l.39-1.28Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.38,408l-.89,5.61s-10.45-3.39-16.22-1.19v-6.9S382,401.76,388.38,408Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,268.23s-22.21,4.35-44-2.71A63,63,0,0,1,341.55,259s.06-1.4.1-3.69c.18-8.94.13-31.43-4.58-37-3-3.51-5.35-25.21.44-36.18l17.71-14.24c24.52,4.79,29.7,11.28,33.75,25.28.75,2.56,1.45,5.37,2.23,8.47.85,3.38,1.65,7.51,2.41,12C397.29,236,399.68,268.23,399.68,268.23Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.61,213.64l-10,44.67s-14.45,4-27.92,7.21A63,63,0,0,1,341.55,259s.06-1.4.1-3.69c12.1-6.19,29.76-15.29,29.62-15.72-.23-.67,0-24,0-24s16-3.71,17.7-22.45c.75,2.56,1.45,5.37,2.23,8.47C392.05,205,392.85,209.1,393.61,213.64Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,268.23s-22.21,4.35-44-2.71A63,63,0,0,1,341.55,259s.06-1.4.1-3.69c.18-8.94.13-31.43-4.58-37-3-3.51-5.35-25.21.44-36.18l17.71-14.24c24.52,4.79,29.7,11.28,33.75,25.28.75,2.56,1.45,5.37,2.23,8.47.85,3.38,1.65,7.51,2.41,12C397.29,236,399.68,268.23,399.68,268.23Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,149.2s-7.82,11.2,2.58,19.94c0,0-12.62,14.16-16.77,12.21-1.75-.82,0-5.93,0-5.93l-7.32-13.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45,155c2.44-10.67,1.27-26.56-13.68-25.15-10.48,1-17.95,6.8-15,20.86,1.23,5.93,2.24,14.33,7.68,21.91,1.51,2.1,17.31-5.33,16.35-11.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.06,148.33a7.24,7.24,0,0,1,6.48.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.54,149.64a1.88,1.88,0,0,1,2.25-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,151.86s-3.08,5.61-3.09,6.41,3.79,1.07,3.79,1.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.9,153c0,.61-.27,1.11-.65,1.13s-.7-.48-.72-1.09.27-1.11.65-1.12S334.88,152.41,334.9,153Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.55,163.42s5.91-1.11,7-3.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.5,141l4.6-1.34s6.45-3,7.82-2.58,4.15,4.69,4.06,7.13c0,0,4.34,3.82,4.89,9.36l1.32-.6s-.07-5,2.77-4.87,4.12,3.53,3.93,4.6-3.3,5.51-3.3,5.51,7.12-1.06,7.35-15S342.89,127,335.46,127.57a97,97,0,0,1-11.32.42l.42,4-3,.79,2.26,2.77-2.48,1.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.26,293s18.1,4.79,23,18.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.55,300.25S348.77,316.54,333.8,325",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.8,391.86s5.56-1.25,7.08-3.41",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,393.93s5.44-2.82,10.86,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.37,318.09s-9.13,23.65-13.75,25.84",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.39,281.05c.25,2.57,11,14.48,19.87,19.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,271a16.57,16.57,0,0,1,.77,10.05,15.49,15.49,0,0,0,0,8.86",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,221.82s16.83,21.78,34.92,28.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,186.61s-.06,14.81,10.62,21.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,208.22c-2.26,2.22.2,30.08.2,30.08s-13.13,5.14-17.24,8.45-23.58,10.91-23.58,10.91-3,10.22.74,10.57,42.47-12.85,51.33-17.48c0,0,5.77-34,5.73-42.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,257.05c-1.8-.34-5-1.52-6.68-1.13s-4.75,2.24-7.91,3-1.85,2,0,2.37a12.45,12.45,0,0,0,4.09,0l-2.57,2.51a40.53,40.53,0,0,1-4.55,2.11c-.93,0-4.22.89-4,2.29s2.11,1.24,4.22,1.32c0,0-3.36.67-3,2.58.22,1.31,4,.13,5.93.13,0,0-1.58,1.72-.4,2.25s3.8-.79,3.8-.79-.1,1.42,1.08,1.56,4.15-1,6.17-2.22a54.74,54.74,0,0,0,5.7-4.22,9.39,9.39,0,0,1,2.59-1.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,269.56a22.88,22.88,0,0,0,2.77-.32c.79-.2,1.58-.46,1.58-.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.89,272.27a9.52,9.52,0,0,0,3.43-1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,273.73a5.83,5.83,0,0,0,2.5-.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6,264.56s-.72,1.65,0,2.57,1.59,1,1.72,2,1.85,1,2.47,1.65,1.09,1.9,3.07,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.59,179.33c-6.81,15.41,0,36.79,0,36.79s16.48,5.6,18,3.19,4.3-14.23,4.77-19.69",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.61,201.33s-7,9.63-12.57,9.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.41,443.43s-1.71-6.53.29-8.95c3.58-4.34-.44-8,3.16-9.49l1.51,1.75c.29-1.77-.55-7.18,6.13-7.88,8.08-.85,8.23,5,8.67,7l-.14-2.71c3.45,0,1.66,3.44,6.88,9.06a14.9,14.9,0,0,1,3.78,11.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,443.43c-3.25-1.45-.27-13.71-.27-13.71s-4.37-2.93,0-6a12.16,12.16,0,0,0,12.41,2s.85-8.2,6-7.15c0,0,1.32,5.2,4.33,8.17,8.15,8,18.68,9,20.44,12.84.53,1.16-.11,3.81-.11,3.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,247.91l4,8.48s16.54,34.18,26.67,73.32c.24.93,5.48,19.47,1.28,65.64l2.4,8.1-2.62,13.38s3.94,5.69,3.8,7.55c0,0-9.72,1.81-13,3.55-2.52,1.36-10.09,8.83-10.09,8.83-2.15-.44-2.34-9.12-2.34-9.12s-4.49-77.07-5.78-80.39-9.17-17.64-21.47-50.41c0,0-.28,45.77-3.56,57.35-2.93,10.3.54,39.13.54,39.13l-2,32.09s6.92,7.19,1.31,9.12c0,0-3.75-7.21-14.43-8.85-5.43-.84-12.19,8.8-12.19,8.8-2.38-.76,1-12.87,1-12.87-7.57-57.12-2-46.78-3.5-74.7-1-17.92-6.05-94.58-.09-100.81Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.26,274.31c26.74,2.1,49.89-6.65,59.94-11.22-1.91-4.28-3.08-6.7-3.08-6.7l-4-8.47-50-1.82C129,248.35,128.25,259.78,128.26,274.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23,297.43c12.17,32.35,20,46.51,21.26,49.81.73,1.92,2.52,28.09,3.92,50.05,1.6-20,3.25-41.07,3.39-45.2.3-8.24-5.65-19.53-6.54-22.45s1.12-6.08,1.12-6.08l-10.7-13.5c.36-4.58-5.31-24.57-5.31-24.57C168,288.68,165,295.47,164.23,297.43Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,247.91l4,8.48s16.54,34.18,26.67,73.32c.24.93,5.48,19.47,1.28,65.64l2.4,8.1-2.62,13.38s3.94,5.69,3.8,7.55c0,0-9.72,1.81-13,3.55-2.52,1.36-10.09,8.83-10.09,8.83-2.15-.44-2.34-9.12-2.34-9.12s-4.49-77.07-5.78-80.39-9.17-17.64-21.47-50.41c0,0-.28,45.77-3.56,57.35-2.93,10.3.54,39.13.54,39.13l-2,32.09s6.92,7.19,1.31,9.12c0,0-3.75-7.21-14.43-8.85-5.43-.84-12.19,8.8-12.19,8.8-2.38-.76,1-12.87,1-12.87-7.57-57.12-2-46.78-3.5-74.7-1-17.92-6.05-94.58-.09-100.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,296.84s6.11-11.79,11.32-15.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,277.94s-18.56,5.65-25,6.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12,259c.8,15.45,6.25,18.08,1,21.45,0,0,.15,7.23-2.47,11.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,253.09s2.19,23.75-5.12,28.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,260.75s-.55,15.81,0,28.55c0,0,1.83,53.85,3.66,60.61s-2.82,17-2.42,46.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,419a7.59,7.59,0,0,0-5.11.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,425.41a28.05,28.05,0,0,0-7.86-5.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,300.57c-4.1,4.6-10.6,13.27-17.26,14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,293.09c-1.26,1.59-2.56,3.15-3.88,4.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.43,346.91S147.11,359.6,142,360.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.39,294.55s16.6,46.23,22.37,50.79c0,0,.65,34,.84,45.87s2.92,27.65,2.92,27.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,418.52s-6.39,2.21-9.5,3.62a8.59,8.59,0,0,0-4.2,4.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,328.67c-8.91-5.59-20.66-12.58-25.4-22.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.84,333.28c-1.69-.93-3.35-1.9-5-2.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.76,265.25c-4.79-.07-10-.7-14.13-3.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,264.8c-1.37.19-2.75.31-4.13.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.26,158.64c-3.66-5.54-22.31-6.95-34.28-6.95s-26.5-2-33.06,11.5c-5,10.31,6.52,64.83,6.52,64.83l-2.82,23.54c21.68,6.8,58.82,5.3,58.82,5.3l-5-21.28S194.92,164.17,191.26,158.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.87,138s1.61,12.83-3.27,15.6c0,0,2.44,9.41,11,10S169.94,155,169.94,155Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,104h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H194.16a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,196,104Z",
    transform: "translate(-9.49 19.5) rotate(-5.27)",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196,104h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H194.16a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,196,104Z",
    transform: "translate(-9.49 19.5) rotate(-5.27)",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.05,
    y: 104.87,
    width: 6.33,
    height: 12.66,
    transform: "translate(-9.31 20.25) rotate(-5.27)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196,104h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H194.16a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,196,104Z",
    transform: "translate(-9.49 19.5) rotate(-5.27)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.88,100.49h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H232a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,233.88,100.49Z",
    transform: "translate(-9.01 22.96) rotate(-5.27)",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.88,100.49h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H232a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,233.88,100.49Z",
    transform: "translate(-9.01 22.96) rotate(-5.27)",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.98,
    y: 101.31,
    width: 3.82,
    height: 12.66,
    transform: "translate(-8.82 23.79) rotate(-5.27)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.88,100.49h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H232a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,233.88,100.49Z",
    transform: "translate(-9.01 22.96) rotate(-5.27)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.92,101.22h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H224a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,225.92,101.22Z",
    transform: "translate(-9.11 22.23) rotate(-5.27)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76,97.73h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H261.88a0,0,0,0,1,0,0V99.61A1.88,1.88,0,0,1,263.76,97.73Z",
    transform: "translate(-8.63 25.69) rotate(-5.27)",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.93,
    y: 102.12,
    width: 6.33,
    height: 12.66,
    transform: "translate(-8.93 22.98) rotate(-5.27)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.35,
    y: 98.66,
    width: 6.33,
    height: 12.66,
    transform: "translate(-8.45 26.4) rotate(-5.27)",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.21,109.42l6.64,71.88L190,192,183.4,120.1a4.55,4.55,0,0,1,4.11-4.95l106.76-9.85A4.54,4.54,0,0,1,299.21,109.42Z",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.21,109.42l6.64,71.88L190,192,183.4,120.1a4.55,4.55,0,0,1,4.11-4.95l106.76-9.85A4.54,4.54,0,0,1,299.21,109.42Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.21,109.42l6.64,71.88L190,192,183.4,120.1a4.55,4.55,0,0,1,4.11-4.95l106.76-9.85A4.54,4.54,0,0,1,299.21,109.42Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.21,109.42l6.64,71.88-86,7.93-6.63-71.88a4.55,4.55,0,0,1,4.11-4.95l76.89-7.1A4.54,4.54,0,0,1,299.21,109.42Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.64,112.51l-73.47,6.78a1.88,1.88,0,0,1-2-1.7h0a1.87,1.87,0,0,1,1.69-2l73.47-6.78a1.88,1.88,0,0,1,2,1.7h0A1.89,1.89,0,0,1,293.64,112.51Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,112.56s-16.95-3.4-18.85,7.51S150,135.62,150,135.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,141.61a29.42,29.42,0,0,1-.87-16.89c1.66-7,10-16.63,22.65-7.88,6.51,4.51,6.91,14.3,4.88,23.26-.48,2.14-.12,4.23-.83,6.2-2.5,6.9-7.07,12.21-9.57,12.33-4.17.21-12.51-4.84-12.17-9.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.89,138.44s-3.37-2.44-6.61-.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,138s2.55-2.34,4.21-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.13,142.18c0,.62.31,1.13.7,1.13s.71-.51.71-1.13-.32-1.12-.71-1.12S162.13,141.56,162.13,142.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.25,
    cy: 141.56,
    rx: 0.71,
    ry: 1.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,140.36c-1.24,1.62.5,7.79,0,8.23s-3.68-.81-3.68-.81-.74-.94.81-1.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,151.69s-4.27,0-5.41-1.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.78,128.58l-.33,5.16s-3.66,1.89-4.58,3.81a7.67,7.67,0,0,0-.58,4s-2.22-3.88-3.42-3.56c-.43.11-.43,1.74-.43,1.74s-5-11.16-.48-17.06S158.78,128.58,158.78,128.58Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,140.44s-1-3.75-4.37-4.74-1.06,8,1.81,9.17,3.59,2,3.76.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14,127.93c-.28-.38-1.52-10,4.83-14.32s17.08-3.86,23.91,2.12,4.89,16.35,0,19.89v-4.33s-2.25,4.34-9,4.7l2.06-3.18s-3.32,2-9.17,1.83c0,0,2.75-2.19,2.35-4.14C162.13,130.5,152.84,135.73,147.14,127.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.33,162.61c-4.68.56-11.34,6.67-7,17.52,2.77,6.88,25.53,2.79,25.53,2.79,8.44-3.48,20.77-16,29.82-21.81,0,0-1.91-12-4.11-10.3-10.23,7.83-18.64,8.37-32.91,15.23C159.69,166,151.27,162.26,148.33,162.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.78,175.93c-.14,4.48,1.7,5.27,4.8,6.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.89,151.69c.21-.65,4-7.31,5.07-9s5.85-3.22,7.7-4.24,2-2.57,3-1.46,0,3.64-5.54,6.33a53.53,53.53,0,0,0,5.91,0c1.48-.22,2.8-1.56,3.46-.63s.79,2.6-2.51,3.62a17.16,17.16,0,0,1-4.88,1,34.26,34.26,0,0,1,4.75,1.38c.53.39,1.32,1.3,2.11,1.44s1.65,1,.2,2a3.6,3.6,0,0,1-3.37.06s3.83,1.85,2.64,3-5,.92-5,.92S199.78,163,195,161.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.66,142.68A1.8,1.8,0,0,1,200,144c.33,1.18,1.3,1.25,1.89,2.57s.42,3.36,1,4.06,0,3.65,0,3.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.31,161.76c-2.45-3.12-7.95-1.71-7.95-1.71",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,154.3s5.66.83,7.33,5.54",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.33,184.12s-5.52,4.27-13.92-1.86",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,185.41s-2.8,3.87-9.62,3.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,234.1s-14.44,11.51-29.11,10",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41,208.81s22.41,16.44,39,17.49",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138,330.51a17.09,17.09,0,0,1,12.65-1.58c7.31,1.84,26.3,29,28.94,31.65s7.58,4,12.13,8.79c7.2,7.51,17.67,14.15,18.73,14.15s1.91-.66,3.23-.92,11.54-1.19,11.54-1.19,3.43.76,0,2.23-3.17,2.78-3.17,2.78-.69,1.11.69,2.17,2.19.48,4.16,3.27-2.78,1.21-2.78,1.21,1.05,3-1.06,2.7-.26,2.93-3.69,2.49-10.77-5.07-12.61-9.92c0,0-29.94-14.31-34.42-18S149,346.86,147.71,346.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H214.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,216.33,357.31Z",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H214.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,216.33,357.31Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.45,
    y: 358.97,
    width: 6.33,
    height: 12.66,
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H214.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,216.33,357.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H252.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,254.33,357.31Z",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H252.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,254.33,357.31Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.54,
    y: 358.97,
    width: 3.82,
    height: 12.66,
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H252.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,254.33,357.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H244.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,246.33,357.31Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,357.31h22a1.88,1.88,0,0,1,1.88,1.88v15.7a0,0,0,0,1,0,0H282.45a0,0,0,0,1,0,0v-15.7A1.88,1.88,0,0,1,284.33,357.31Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.45,
    y: 358.97,
    width: 6.33,
    height: 12.66,
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.03,
    y: 358.97,
    width: 6.33,
    height: 12.66,
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,371.23v72.19H203.11V371.23a4.55,4.55,0,0,1,4.55-4.55H314.87A4.55,4.55,0,0,1,319.42,371.23Z",
    style: {
      fill: "#556EE6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.42,371.23v72.19H203.11V371.23a4.55,4.55,0,0,1,4.55-4.55H314.87A4.55,4.55,0,0,1,319.42,371.23Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,371.23v72.19H203.11V371.23a4.55,4.55,0,0,1,4.55-4.55H314.87A4.55,4.55,0,0,1,319.42,371.23Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,371.23v72.19H233.11V371.23a4.55,4.55,0,0,1,4.55-4.55h77.21A4.55,4.55,0,0,1,319.42,371.23Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,373.8H239.8a1.88,1.88,0,0,1-1.88-1.88h0A1.88,1.88,0,0,1,239.8,370h73.78a1.88,1.88,0,0,1,1.88,1.88h0A1.88,1.88,0,0,1,313.58,373.8Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,443.42c-6,0-14.43-3.86-24.14-7.94-10.07-4.24-21.54-8.72-33.18-9.39-4.34-.25-1.71,17.33-1.71,17.33h-9.5S99.09,430.9,98,419.69c0,0,7.66-4.73,9.5-5a16.76,16.76,0,0,1,1.91-.09c2.06,0,4.81.09,4.81.09h0c-.44-.26-7.45-4.48-11.32-8.77-3.19-3.54-4.65-9.13-4.76-12.47a61.16,61.16,0,0,1,.73-6.6l49.92.83s.54.38,1.5,1.09c5.79,4.22,26.95,19.94,37.53,31.79,3.42,3.83,5.73,7.25,6.07,9.75C195.48,441.84,186.05,443.42,177,443.42Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,420.54l-24.28,5.55a35.81,35.81,0,0,0-10.71,9.39c-10.07-4.24-21.54-8.72-33.18-9.39-4.34-.25-1.71,17.33-1.71,17.33h-9.5S99.09,430.9,98,419.69c0,0,8.84,12.6,11,19,0,0,3.43-11.84,9-16.59a45.66,45.66,0,0,0-8.51-7.47c2.06,0,4.81.09,4.81.09h0c-.44-.26-7.45-4.48-11.32-8.77-3.19-3.54-4.48-9.14-4.76-12.47-.14-1.64.06-6.6.06-6.6s37.23,5.31,52.09,1.92C156.09,393,177.25,408.69,187.83,420.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8,419.69s19.78,9.91,25.06,13.79,6.85,2.83,6.85,2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.91,418.64s4.75,7.25,5,9.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,279.48S193,274.9,192,294.38s2.57,20.48,2.57,20.48-26.5,10.88-33.23,1.58S161,281.69,182.47,279.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,314.86s-10.9,5.14-11.89,9.89-14.64-2.4-14.64-2.4l9.89-14.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.53,367c-25,31.84-4.71,47.2,23.63,44.66l-5.68,9,14.26,2.47s10.93-7.14,25.83-14.77c25.36-13,35.61-12.22,33-25.23s-33.69-21.45-64.85-7.74C135.69,375.38,118.77,355.28,109.53,367Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.25,436.31s6.51-18,9.23-19,13,2.9,14.26,5.8c0,0,3.47-5.32,4.89-3.06s-.63,6,0,8.86,7.66,6.86,10.47,7.39,4.41,2.11,4.41,3.69v3.43H118.25A9.05,9.05,0,0,1,118.25,436.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.63,426.09s-5.73,2.83-7.82,2,1.07,4.75,1.86,5.28,6-1.85,6-1.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.66,423.12s7.78.15,10.15,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.25,436.31s12.4,2.9,13.45,2.9a30.17,30.17,0,0,0,5-1.45s3.4,1.71,5.66,2.77,17,0,17,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16,411.68C145,410.4,168,395.81,176,390.74S186,387,186,387",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,386.83l1.89-14.35,4.56-3.44c7.39-17.93,40.87-51.42,50-51.31,13.71.16,16.13,14.55,17.82,30.3s-19.67,13.38-19.67,13.38v3.95l-12.15,6.29,7.36-.23S126.85,392,98.21,386.83Z",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,290c2.87-9,16-11.4,20.72-9.93a16.79,16.79,0,0,1,8.91,8.13c1.2,2.59-1.31,7.17.48,9.84,2.56,3.83,2.34,11.91,1.42,17-.5,2.7-11.73,4.3-20.91-2C158.31,306.22,154.77,298.66,157.55,290Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.82,277.38s11.56-1.88,11.64,1.09c.51,19.73-11.32,23.87-11.32,23.87s-4.83-3.85-5.91-1.21,1.7,9.94,5.12,10.09a7.82,7.82,0,0,0-.14,8.24s-19.58,3.27-21.2-5.8a71.4,71.4,0,0,0,1.62-9.58C151.9,291.37,148.93,282.82,170.82,277.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,297.49c2.41,2.17,4.14,2.17,4.11,2.95-.09,2.43-3,3.64-3,3.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,308.13a8.87,8.87,0,0,1-5.27.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,285.38s7.69-2.23,6.28,10.25c0,0,3.2-4.35,3.19-9.24,0-8.47-11.33-6.77-11.33-6.77l1.48,6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.89,291.49a2.59,2.59,0,0,0-2-.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.71,291.35s-4.13.24-5.92,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72,297.92c.06.66-.22,1.23-.63,1.27s-.79-.47-.86-1.13.22-1.23.63-1.27S181.66,297.26,181.72,297.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,414.68s9.2,1,11.2,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.1,324.48a17.09,17.09,0,0,1,12.65-1.58c7.32,1.85,26.3,29,28.94,31.65s7.58,4,12.13,8.79c7.2,7.51,17.67,14.15,18.73,14.15s1.91-.66,3.23-.92,11.54-1.19,11.54-1.19,3.43.77,0,2.23-3.17,2.79-3.17,2.79-.68,1.1.69,2.16,2.19.48,4.16,3.27-2.78,1.21-2.78,1.21,1.05,3-1.06,2.7-.26,2.93-3.69,2.49-10.77-5.07-12.61-9.92c0,0-29.94-14.31-34.42-18s-23.32-23.48-24.65-23.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,321.58s14.76-3.95,19.91-1.05,14.91,16.35,14.91,16.35-11.9,10.65-15.58,9.68S157.1,344,157.1,344",
    style: {
      fill: "#556EE6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,345.3s-5.35,2.94-7.32,2.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.1,330.55c.45.79.3,9.44,9.69,12.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91,369.32s20,3.43,26.9-2.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65,371.65s-5-.88-6.84,1.69-11.86,5-11.86,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.45,390.74s-2.89,12.46,9.44,18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91,391.6s.07,6.14,2,9.5l6.13,2,6.86-3.82s-1.46-7.85-1.59-9.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.58c6b5609d4ed2664ac21ba33d2fe679.svg";
export { ForwardRef as ReactComponent };